import { HtmlControlType } from './../enums/htmlControlType';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isDropdown',
    standalone: false
})
export class IsDropdownPipe implements PipeTransform {

	transform(value: HtmlControlType): boolean {
		return value === HtmlControlType.Dropdown || value === HtmlControlType.List;
	}
}
